/* gp-reviews.js — behaviour for the gp-product-reviews section.
   Every review is already in the DOM (rendered by Liquid); this file only decides which ones are shown,
   in what order, on which page — plus the photo lightbox, the helpful votes, sharing and the form.
   No network calls: submitting a review shows a confirmation and nothing else, by design. */
(function () {
  function init(root) {
    if (root._gpInit) return;
    root._gpInit = true;

    var list = root.querySelector('[data-gp-rv-list]');
    if (!list) return;
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-gp-rv-item]'));
    var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 5;
    var state = { q: '', sort: root.getAttribute('data-sort') || 'recent', star: 0, page: 1 };

    var searchEl = root.querySelector('[data-gp-rv-search]');
    var sortEl = root.querySelector('[data-gp-rv-sort]');
    var pagEl = root.querySelector('[data-gp-rv-paginate]');
    var noneEl = root.querySelector('[data-gp-rv-none]');
    var clearEl = root.querySelector('[data-gp-rv-clear]');

    /* ---- index the cards once, so filtering never touches the DOM to read ---- */
    var data = items.map(function (el) {
      return {
        el: el,
        rating: parseInt(el.getAttribute('data-rating'), 10) || 0,
        days: parseInt(el.getAttribute('data-days'), 10) || 0,
        up: parseInt(el.getAttribute('data-up'), 10) || 0,
        photos: parseInt(el.getAttribute('data-photos'), 10) || 0,
        index: parseInt(el.getAttribute('data-index'), 10) || 0,
        text: (el.textContent || '').toLowerCase()
      };
    });

    // "days" is how long ago a review was left, so newest first means the smallest number first
    var sorters = {
      recent: function (a, b) { return a.days - b.days || a.index - b.index; },
      highest: function (a, b) { return b.rating - a.rating || a.days - b.days; },
      lowest: function (a, b) { return a.rating - b.rating || a.days - b.days; },
      helpful: function (a, b) { return b.up - a.up || a.days - b.days; },
      photos: function (a, b) { return (b.photos ? 1 : 0) - (a.photos ? 1 : 0) || a.days - b.days; }
    };

    function matching() {
      return data.filter(function (d) {
        if (state.star && d.rating !== state.star) return false;
        if (state.q && d.text.indexOf(state.q) === -1) return false;
        return true;
      }).sort(sorters[state.sort] || sorters.recent);
    }

    function render() {
      var rows = matching();
      var pages = Math.max(1, Math.ceil(rows.length / perPage));
      if (state.page > pages) state.page = pages;
      var start = (state.page - 1) * perPage;

      items.forEach(function (el) { el.hidden = true; });
      rows.slice(start, start + perPage).forEach(function (d) {
        d.el.hidden = false;
        list.appendChild(d.el); // re-appending in order is what applies the sort
      });

      if (noneEl) noneEl.hidden = rows.length !== 0;
      if (clearEl) clearEl.hidden = !state.star;
      renderPagination(pages);
    }

    function pageButton(label, page, opts) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gp-rv__page' + (opts && opts.current ? ' is-current' : '');
      b.innerHTML = label;
      if (opts && opts.disabled) b.disabled = true;
      else b.addEventListener('click', function () {
        state.page = page;
        render();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      return b;
    }

    var CHEVRON_L = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>';
    var CHEVRON_R = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>';

    function renderPagination(pages) {
      if (!pagEl) return;
      pagEl.innerHTML = '';
      if (pages < 2) return;
      var first = Math.max(1, Math.min(state.page - 1, pages - 2));
      var last = Math.min(pages, first + 2);
      if (state.page > 1) {
        pagEl.appendChild(pageButton(CHEVRON_L + CHEVRON_L, 1));
        pagEl.appendChild(pageButton(CHEVRON_L, state.page - 1));
      }
      for (var p = first; p <= last; p++) pagEl.appendChild(pageButton(String(p), p, { current: p === state.page }));
      if (state.page < pages) {
        pagEl.appendChild(pageButton(CHEVRON_R, state.page + 1));
        pagEl.appendChild(pageButton(CHEVRON_R + CHEVRON_R, pages));
      }
    }

    if (searchEl) searchEl.addEventListener('input', function () { state.q = this.value.trim().toLowerCase(); state.page = 1; render(); });
    if (sortEl) { sortEl.value = state.sort; sortEl.addEventListener('change', function () { state.sort = this.value; state.page = 1; render(); }); }

    root.querySelectorAll('[data-gp-rv-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var star = parseInt(btn.getAttribute('data-gp-rv-filter'), 10);
        state.star = state.star === star ? 0 : star;
        state.page = 1;
        root.querySelectorAll('[data-gp-rv-filter]').forEach(function (b) { b.classList.remove('is-active'); });
        if (state.star) btn.classList.add('is-active');
        render();
      });
    });
    if (clearEl) clearEl.addEventListener('click', function () {
      state.star = 0; state.page = 1;
      root.querySelectorAll('[data-gp-rv-filter]').forEach(function (b) { b.classList.remove('is-active'); });
      render();
    });

    /* ---- helpful votes: display-only, but remembered so one visitor cannot keep stacking ---- */
    var VOTE_KEY = 'gpReviewVotes';
    function votes() { try { return JSON.parse(localStorage.getItem(VOTE_KEY) || '{}'); } catch (e) { return {}; } }
    function saveVote(key, dir) {
      var v = votes(); v[key] = dir;
      try { localStorage.setItem(VOTE_KEY, JSON.stringify(v)); } catch (e) {}
    }
    var saved = votes();
    items.forEach(function (el) {
      var key = el.getAttribute('data-key');
      var mark = function (dir) {
        var btn = el.querySelector('[data-gp-rv-vote="' + dir + '"]');
        if (btn) btn.classList.add('is-voted');
      };
      if (saved[key]) mark(saved[key]);
      el.querySelectorAll('[data-gp-rv-vote]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-gp-rv-vote');
          if (saved[key]) return;
          var count = el.querySelector('[data-gp-rv-count="' + dir + '"]');
          if (count) count.textContent = (parseInt(count.textContent, 10) || 0) + 1;
          saved[key] = dir;
          saveVote(key, dir);
          mark(dir);
        });
      });
      el.querySelectorAll('[data-gp-rv-share]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var url = encodeURIComponent(location.href.split('#')[0]);
          var titleEl = el.querySelector('.gp-rv__title');
          var text = encodeURIComponent(titleEl ? titleEl.textContent : document.title);
          var net = btn.getAttribute('data-gp-rv-share');
          var target = net === 'facebook' ? 'https://www.facebook.com/sharer/sharer.php?u=' + url
            : net === 'twitter' ? 'https://twitter.com/intent/tweet?url=' + url + '&text=' + text
              : 'https://pinterest.com/pin/create/button/?url=' + url + '&description=' + text;
          window.open(target, '_blank', 'noopener,width=640,height=560');
        });
      });
    });

    /* ---- photo lightbox ---- */
    var lb = root.querySelector('[data-gp-rv-lightbox]');
    if (lb) {
      var lbImg = lb.querySelector('[data-gp-rv-lb-img]');
      var photos = [], at = 0;
      var show = function (i) {
        at = (i + photos.length) % photos.length;
        lbImg.src = photos[at];
        lb.hidden = false;
        document.body.style.overflow = 'hidden';
      };
      var close = function () { lb.hidden = true; lbImg.src = ''; document.body.style.overflow = ''; };
      root.querySelectorAll('[data-gp-rv-photo]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          // collect the visible photos each time, so the lightbox follows the current filter
          photos = Array.prototype.slice.call(root.querySelectorAll('[data-gp-rv-photo]'))
            .filter(function (b) { return b.offsetParent !== null; })
            .map(function (b) { return b.getAttribute('data-gp-rv-photo'); });
          var idx = photos.indexOf(btn.getAttribute('data-gp-rv-photo'));
          show(idx < 0 ? 0 : idx);
        });
      });
      lb.querySelector('[data-gp-rv-lb-close]').addEventListener('click', close);
      lb.querySelector('[data-gp-rv-lb-prev]').addEventListener('click', function () { show(at - 1); });
      lb.querySelector('[data-gp-rv-lb-next]').addEventListener('click', function () { show(at + 1); });
      lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') show(at - 1);
        if (e.key === 'ArrowRight') show(at + 1);
      });
    }

    /* ---- write a review: local only ---- */
    var formWrap = root.querySelector('[data-gp-rv-form-wrap]');
    var form = root.querySelector('[data-gp-rv-form]');
    if (formWrap && form) {
      var writeBtn = root.querySelector('[data-gp-rv-write]');
      var thanks = root.querySelector('[data-gp-rv-thanks]');
      var errEl = root.querySelector('[data-gp-rv-error]');
      var rating = 0;

      if (writeBtn) writeBtn.addEventListener('click', function () {
        formWrap.hidden = !formWrap.hidden;
        if (!formWrap.hidden) formWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      var cancel = root.querySelector('[data-gp-rv-cancel]');
      if (cancel) cancel.addEventListener('click', function () { formWrap.hidden = true; });

      root.querySelectorAll('[data-gp-rv-form-stars] .gp-rv__form-star').forEach(function (btn) {
        btn.addEventListener('click', function () {
          rating = parseInt(btn.getAttribute('data-value'), 10);
          root.querySelectorAll('[data-gp-rv-form-stars] .gp-rv__form-star').forEach(function (b) {
            var on = parseInt(b.getAttribute('data-value'), 10) <= rating;
            b.classList.toggle('is-on', on);
            b.setAttribute('aria-checked', on && parseInt(b.getAttribute('data-value'), 10) === rating ? 'true' : 'false');
          });
        });
      });

      var fileEl = form.querySelector('input[type="file"]');
      var preview = root.querySelector('[data-gp-rv-preview]');
      if (fileEl && preview) fileEl.addEventListener('change', function () {
        preview.innerHTML = '';
        var f = fileEl.files && fileEl.files[0];
        if (!f) return;
        var img = document.createElement('img');
        img.src = URL.createObjectURL(f);
        img.alt = 'Your photo';
        preview.appendChild(img);
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var name = form.querySelector('[name="name"]').value.trim();
        var email = form.querySelector('[name="email"]').value.trim();
        var body = form.querySelector('[name="body"]').value.trim();
        var ok = rating > 0 && body && name && /.+@.+\..+/.test(email);
        if (!ok) {
          if (errEl) { errEl.hidden = false; errEl.textContent = form.getAttribute('data-error'); }
          return;
        }
        if (errEl) errEl.hidden = true;
        form.hidden = true;
        if (thanks) thanks.hidden = false;
      });
    }

    render();
  }

  function boot() {
    document.querySelectorAll('[data-gp-reviews]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // the theme editor re-renders sections without a page load
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-gp-reviews]');
    if (root) init(root);
  });
})();
